


















import { Component, Prop, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";

@Component({
  components: {
    "cprod-prov-config-details": () =>
      import(
        `@/components/app/global/contractProducts/cProdProvConfigDetails.vue`
      )
  }
})
export default class CProdProvConfigDetailsComponent extends Mixins(
  CProdInjectorMixin,
  CProdProvInjectorMixin
) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    if (this.cProdData.isAwaitingSetup) return false;
    return !!this.cProdProvData.contractProductFields?.length;
  }
}
